// extracted by mini-css-extract-plugin
module.exports = {"toolTips":"toolTips"};